import type { CreateRoomResponse } from '@protocol';

export async function createRoom(): Promise<string> {
  const res = await fetch('/api/rooms', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) {
    throw new Error(
      res.status === 403
        ? 'This site is not allowed to create rooms. Check the Worker’s ALLOWED_ORIGINS.'
        : `Could not create a room (${res.status}).`,
    );
  }
  const body = (await res.json()) as CreateRoomResponse;
  if (typeof body.code !== 'string' || body.code.length === 0) {
    throw new Error('The server returned an unusable room code.');
  }
  return body.code;
}
